import React, { useState } from "react";
import classes from "./Drawer.module.css";
import { useNavigate } from "react-router-dom";

const Drawer = ({ drawer, setDrawer , setOpen}) => {
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        setDrawer(false);
        navigate(path);
    }

    return (
        <div
            className={`${classes.drawer} ${drawer && classes.show}`}
            onClick={() => setDrawer(false)}
        >
            <div
                className={classes.drawer_container}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={classes.menu_items}>
                    <button className={classes.menu_item}
                        onClick={() => handleNavigate("/")}
                    >
                        Home
                    </button>
                    <div className={classes.divider}></div>

                    <button className={classes.menu_item}
                        onClick={() => handleNavigate("/category/rhymes")}
                    >
                        Categories
                    </button>
                    <div className={classes.divider}></div>

                    <button className={classes.menu_item}
                        onClick={() => handleNavigate("/category/rhymes")}
                    >
                        Watch Now
                    </button>

                    <div className={classes.divider}></div>

                    <button className={classes.menu_item}
                        onClick={() => {
                            setDrawer(false)
                            setOpen(true)
                        }}
                    >
                        Unsubscribe
                    </button>


                </div>
            </div>

        </div>
    );
};

export default Drawer;